import { ENABLE_I18N } from '@src/config/env'

export default function withI18nGate<P extends object>(Component: React.ComponentType<P>, showChildren = false) {
  return function WithI18nGate(props: P & { children?: React.ReactNode }) {
    if (!ENABLE_I18N) return showChildren ? props.children : null
    return <Component {...props} />
  }
}
